import {
  Stack,
  Flex,
  Text,
  FormHelperText,
  FormErrorMessage,
  StackProps,
  FormHelperTextProps,
  FormErrorMessageProps,
  Box,
  FormErrorIcon
} from "@/storybook-components";

interface QuestionFooterProps extends StackProps {
  answerLength?: number;
  notes?: string;
  maxLength?: number;
  maxLengthNote?: string;
  error?: string;
  helperTextStyles?: FormHelperTextProps;
  errorMsgStyles?: FormErrorMessageProps;
  withErrorIcon?: boolean;
  locale?: string;
}

const QuestionFooter = (props: QuestionFooterProps) => {
  const {
    answerLength,
    notes,
    maxLength = null,
    maxLengthNote,
    error,
    helperTextStyles,
    errorMsgStyles,
    spacing,
    withErrorIcon,
    locale = "en",
    ...rest
  } = props;

  if (!maxLength && !error && !notes) {
    return null;
  }
  const formatNumberByLocale = (num: number) => {
    return Intl.NumberFormat(locale).format(num);
  };
  return (
    <Stack
      {...rest}
      spacing={spacing}
      direction="column"
      justifyContent={notes || error ? "space-between" : "flex-end"}
    >
      {error && (
        <FormErrorMessage {...{ mt: 0, ...errorMsgStyles }}>
          {withErrorIcon && <FormErrorIcon />} {error}
        </FormErrorMessage>
      )}
      {(maxLength || notes) && (
        <FormHelperText width="100%" {...{ mt: 0, ...helperTextStyles }}>
          <Stack spacing={spacing}>
            {maxLength && maxLengthNote && (
              <Flex
                justifyContent={maxLengthNote ? "space-between" : "flex-end"}
              >
                {maxLengthNote && <Text>{maxLengthNote}</Text>}
                <Text>{`${formatNumberByLocale(answerLength)}/${formatNumberByLocale(maxLength)}`}</Text>
              </Flex>
            )}
            {notes && <Box {...helperTextStyles}>{notes}</Box>}
          </Stack>
        </FormHelperText>
      )}
    </Stack>
  );
};

export { QuestionFooter };
export type { QuestionFooterProps };
